// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesOutcomes } from '../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { makeComplexeMatchBetsSelector } from '../../selectors/match.selector';
import { type Selector } from '../../types/selectors';
import { createResultEqualSelector } from '../../utils/reselect';

export type HotBetGroupOutcomeData = {
  betId: number;
  outcomeId: number;
  isMultichoice: boolean;
};
const makeMatchHotGroupsPropsSelector = () => {
  const selectComplexeMatchBets = makeComplexeMatchBetsSelector();

  const selectOutcomesData: Selector<Array<HotBetGroupOutcomeData>> = createResultEqualSelector(
    [selectComplexeMatchBets, selectEntitiesOutcomes],
    (complexeMatchBets, outcomesMap) =>
      complexeMatchBets
        .reduce(
          (acc, betData) => [
            ...acc,
            ...betData.bet.outcomes.reduce((acc, outcomeId) => {
              const { hotUsers } = outcomesMap[outcomeId] ?? {};

              if (hotUsers) {
                return [
                  ...acc,
                  {
                    betId: betData.bet.betId,
                    outcomeId,
                    isMultichoice: betData.isMultichoice,
                    hotUsers,
                  },
                ];
              }

              return acc;
            }, []),
          ],
          [],
        )
        .sort((a, b) => b.hotUsers - a.hotUsers)
        .map(
          ({
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            hotUsers,
            ...rest
          }) => rest,
        ),
  );

  return createSelector([selectOutcomesData], (outcomesData) => ({
    outcomesData,
  }));
};

export default makeMatchHotGroupsPropsSelector;
